<template>
  <div v-if="isPC" class="content-area">
    <div class="carousel-wrapper" v-show="!nodata">
      <Slide :picts="resources" />
    </div>
    <div v-show="nodata">
      <div style="color: #fff;padding: 20px;text-align: center;">暂无数据</div>
    </div>
  </div>
  <div v-else class="m-content-area" id="m-content-area">
    <div class="carousel-wrapper" v-show="!nodata">
      <Slide :picts="resources" />
    </div>
    <div v-show="nodata">
      <div style="color: #fff;padding: 20px;text-align: center;">暂无数据</div>
    </div>
  </div>
</template>

<script>
import Slide from '@/common/Slide'
export default {
  name: 'PdfView',
  components: { Slide },
  props: ['popInKr', 'id'],
  data () {
    return {
      productInfo: {}, 
      resources: [],
      isIdle: true,
      nodata: false,
    }
  },
  mounted () {
    if (this.id) {
      this.initData(this.id)
    }
  },
  methods: {
    initData (id) {
      let data = this.$allData[this.currentLang] || []
      for (let item of data) {
        if (item.uuid === id || item.boothNo === id) {
          item = this.transformData(item)
          this.productInfo = item
          break
        }
      }
    },
    transformData (itemInfo) {
      let resources = []
      // pdf 处理
      if (itemInfo.innovateResults) {
        resources.push({
          type: 'pdf',
          url: itemInfo.innovateResults
        })
      }
      this.resources = resources
      this.nodata = this.resources.length === 0
      return itemInfo
    },
  }
}
</script>

<style scoped>
.content-area {
  width:100%;
  min-height: 100%;
  background-color: rgba(0,0,0,0.6);
  text-align: center;
}
.carousel-wrapper {
  margin: 0 auto;
  padding-top: 10rem;
  width: 80rem;
  height: 46rem;
}
#m-content-area {
  box-sizing: border-box !important;
}
.m-content-area {
  width: 100%;
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  background-color: rgba(0,0,0,0.6);
}
.m-content-area .carousel-wrapper {
  padding: 20px 0 0 0;
  width: 100%;
  position: relative;
}
</style>